import Devices from "../../components/inventory/Devices";

const Controllers = () => (
    <div>
        <Devices />
    </div>
);

export default Controllers;